var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","color":_vm.color},scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.iconColor,"small":""}},'v-icon',attrs,false),on),[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")])]}}])},[_vm._v(" "),_c('div',{style:(_vm.style)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }